import PropTypes from 'prop-types';
import { Base64 } from 'js-base64';

export const cookiesShape = PropTypes.shape({
  get: PropTypes.func.isRequired,
  set: PropTypes.func.isRequired,
  remove: PropTypes.func.isRequired,
});

export function encodeData(data) {
  return Base64.encodeURI(JSON.stringify(data));
}

export function decodeData(str) {
  if (str == null || str === '') {
    return {};
  }
  return JSON.parse(Base64.decode(str));
}
